// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Dialog = require("./Dialog.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");

function useModalRef(param) {
  return React.useRef(null);
}

function modalRefToModalMethods(modalRef) {
  var modalMethods = modalRef.current;
  if (modalMethods == null) {
    return Js_exn.raiseError("modalRef.current is null");
  } else {
    return modalMethods;
  }
}

function openModal(modalRef, render) {
  return Curry._1(modalRefToModalMethods(modalRef).openModal, render);
}

function updateModal(modalRef, modalId, render) {
  Curry._2(modalRefToModalMethods(modalRef).updateModal, modalId, render);
}

function closeModal(modalRef, modalId) {
  Curry._1(modalRefToModalMethods(modalRef).closeModal, modalId);
}

function openModalPriv(st, render) {
  var id = String(st.nextId);
  return [
          {
            nextId: st.nextId + 1 | 0,
            modals: st.modals.concat([{
                    id: id,
                    render: render
                  }])
          },
          id
        ];
}

function Modal(Props) {
  var modalRef = Props.modalRef;
  var match = React.useState(function () {
        return {
                nextId: 0,
                modals: []
              };
      });
  var setState = match[1];
  modalRef.current = React.useMemo((function () {
          return {
                  openModal: (function (render) {
                      return Expln_utils_promise.promise(function (rlv) {
                                  Curry._1(setState, (function (prev) {
                                          var match = openModalPriv(prev, render);
                                          Curry._1(rlv, match[1]);
                                          return match[0];
                                        }));
                                });
                    }),
                  updateModal: (function (modalId, render) {
                      Curry._1(setState, (function (__x) {
                              return {
                                      nextId: __x.nextId,
                                      modals: __x.modals.map(function (m) {
                                            if (m.id === modalId) {
                                              return {
                                                      id: m.id,
                                                      render: render
                                                    };
                                            } else {
                                              return m;
                                            }
                                          })
                                    };
                            }));
                    }),
                  closeModal: (function (modalId) {
                      Curry._1(setState, (function (__x) {
                              return {
                                      nextId: __x.nextId,
                                      modals: __x.modals.filter(function (m) {
                                            return m.id !== modalId;
                                          })
                                    };
                            }));
                    })
                };
        }), []);
  return React.createElement(React.Fragment, undefined, match[0].modals.map(function (modal) {
                  return React.createElement(Dialog.make, {
                              opn: true,
                              maxWidth: "xl",
                              children: Curry._1(modal.render, undefined),
                              key: modal.id
                            });
                }));
}

function rndProgress(text, pct) {
  return React.createElement("span", {
              style: {
                padding: "10px"
              }
            }, "" + text + ": " + String(Math.round(pct * 100) | 0) + "%");
}

var make = Modal;

exports.useModalRef = useModalRef;
exports.openModal = openModal;
exports.updateModal = updateModal;
exports.closeModal = closeModal;
exports.rndProgress = rndProgress;
exports.make = make;
/* react Not a pure module */
